// Mock implementations for the Google Calendar OAuth endpoints
// (contract: docs/superpowers/specs/2026-07-28-google-calendar-connect-design.md §6).
// Connection state persists in localStorage so demos survive a refresh.
// Pure module (no axios) — unit-testable under CRA5 Jest.

import { MOCK_GCAL_AUTHORIZE_URL } from "./gcalUtils";

const STORAGE_KEY = "zoey_gcal_mock_connection";

const storage = () => (typeof window === "undefined" ? null : window.localStorage);

export const readMockGcalConnection = () => {
  try {
    const raw = storage()?.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (e) {
    return null;
  }
};

export const mockGcalStatus = () => {
  const stored = readMockGcalConnection();
  return {
    connected: !!stored,
    authorize_url: MOCK_GCAL_AUTHORIZE_URL,
    // Keep "last synced" looking fresh on every load.
    connection: stored
      ? { ...stored, last_synced_at: new Date(Date.now() - 2 * 60 * 1000).toISOString() }
      : null,
  };
};

export const mockGcalConnect = ({ code } = {}) => {
  if (!code || code === "mock-fail") {
    throw new Error("Google did not authorize the connection. Please try again.");
  }
  const connection = {
    email: "calgary@3dlifestyle.ca",
    calendar_id: "primary",
    upcoming_events: 128,
    connected_at: new Date().toISOString(),
    last_synced_at: new Date().toISOString(),
  };
  try {
    storage()?.setItem(STORAGE_KEY, JSON.stringify(connection));
  } catch (e) {}
  return { connection };
};

export const mockGcalDisconnect = () => {
  try {
    storage()?.removeItem(STORAGE_KEY);
  } catch (e) {}
  return true;
};
